import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from 'js-cookie';

import AdminLogin from './admin/pages/AdminLogin';
import AdminLayout from './admin/components/AdminLayout';

import AdminDashboard from './admin/pages/AdminDashboard';
import AdminUsers from './admin/pages/AdminUsers';
import AdminTransactions from './admin/pages/AdminTransactions';
import AdminTradeControl from './admin/pages/AdminTradeControl';
import AdminWalletSettings from './admin/pages/AdminWalletSettings';
import AdminUserWalletBalance from './admin/pages/AdminUserWalletBalance';
import AdminContentManagement from './admin/pages/AdminContentManagement';
import AdminSupport from './admin/pages/AdminSupport';
import AdminNotifications from './admin/pages/AdminNotifications';

const isAuthenticated = !!Cookies.get('isAdminLoggedIn');

function App() {
  return (
    <Router>
      <ToastContainer
        position='top-right'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='light'
      />
      <Routes>
        {/* Root redirect to admin */}
        <Route path='/' element={<Navigate to='/admin' replace />} />

        {/* Admin redirect based on authentication */}
        <Route
          path='/admin'
          element={
            isAuthenticated ? (
              <Navigate to='/admin/dashboard' replace />
            ) : (
              <Navigate to='/admin/login' replace />
            )
          }
        />

        {/* Admin login page */}
        <Route path='/admin/login' element={<AdminLogin />} />

        {/* Protected Admin layout for nested pages */}
        <Route path='/admin/*' element={<AdminLayout />}>
          <Route path='dashboard' element={<AdminDashboard />} />
          <Route path='users' element={<AdminUsers />} />
          <Route
            path='user-wallet-balance'
            element={<AdminUserWalletBalance />}
          />
          <Route path='transactions' element={<AdminTransactions />} />
          <Route path='trade-control' element={<AdminTradeControl />} />
          {/* <Route path='access' element={<AdminAccessControl />} /> */}
          <Route path='wallets' element={<AdminWalletSettings />} />
          <Route path='content' element={<AdminContentManagement />} />
          <Route path='notifications' element={<AdminNotifications />} />
          <Route path='support' element={<AdminSupport />} />
        </Route>

        {/* Catch-all route for unmatched paths */}
        <Route path='*' element={<Navigate to='/admin' replace />} />
      </Routes>
    </Router>
  );
}

export default App;
